
import Image from "next/image";
import styles from "./ediror.module.scss";
import { HandySvg } from "handy-svg";
import { useEffect, useState } from "react";
import { getBackgrounds } from "../../../pages/api/sportcards";
import { useStore } from "../../../stores/use_global_state";


const Background = ({ sportCardsState, setSportCardsState, setSteps }) => {
  const { state } = useStore();
  let token = state?.userInfo?.token ? state.userInfo.token : false;
  const [backgrounds, setBackgrounds] = useState([]);

  useEffect(() => {
    const getPosesList = async () => {
      const response = await getBackgrounds(token);
      setBackgrounds(response.data);
    }
    getPosesList()
  }, [])

  const Next = () => {
    setSteps(prev => prev.map(step => step.name === "Logo" ? { ...step, active: true } : { ...step, active: false }));
  }

  return (
    <>
      <div className={styles.backgroundWrapeer}>
        {/* <label className={`${styles.background} ${styles.backgroundUpload}`}>
          <input type="file" accept="image/*" />
          <Image src={"/sport_cards/download.png"} alt="pose" width="24" height="24" quality={99} unoptimized />

          <p className={styles.logoItemText}>Upload image</p>
        </label> */}
        {backgrounds.map((background) => (
          <button key={background.id} onClick={() => setSportCardsState({ ...sportCardsState, background: background })} className={`${styles.background} ${background.id === sportCardsState.background?.id ? styles.active : ""}`}>
            <Image src={background.image_url} alt="pose" width="171" height="239" quality={99} unoptimized />
          </button>
        ))}
      </div>
      <button onClick={Next} disabled={sportCardsState.background === null} className={styles.nextBtn}>Next <HandySvg src={"/illustration_service/next.svg"} width={24} height={24} fill={"transparent"} /></button>
    </>
  )
}

export default Background